import * as countries from 'i18n-iso-countries';
import { useTranslation } from "react-i18next";
import { MuiRhfAutocompleteListField } from "../../components/forms/MuiRhfAutocompleteListField";
import { useEffect, useState } from "react";
import { AutocompleteProps } from "@mui/material";

export function CountriesSelectField(props: {
  name: string,
  required?: boolean;
  size?: "small";
} & Partial<
  Omit<AutocompleteProps<string, false, false, false>, "onChange" | "onBlur" | "value" | "name" | "error">
>) {
  const {
    name,
    required,
    ...autoCompleteAndFormControlProps
  } = props;
  const { t, i18n } = useTranslation();
  const [ countryList, setCountryList ] = useState(Object.keys(countries.getNames(i18n.language)));
  const [ countryTranslations, setCountryTranslations ] = useState(countries.getNames(i18n.language));

  useEffect(() => {
    // console.log("Setting country list to " + i18n.language + " ones.");
    setCountryList(Object.keys(countries.getNames(i18n.language)));
    setCountryTranslations(countries.getNames(i18n.language));
  }, [ i18n.language ]);

  return (
    <MuiRhfAutocompleteListField
      name={name}
      label={t("Company.country")}
      list={countryList}
      getListLabel={entry => countryTranslations[entry]}
      {...autoCompleteAndFormControlProps}
    />
  );
}
